// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule, ROUTES} from '@angular/router';
// Service
import { ComponentFactoryResolverService, RoleGuard } from '@cv-invision/core';
import { setRoutesByPermissions } from './service/routes-handle.service';

const routes: Routes = [
	{
		path: '',
		canActivate: [RoleGuard],
		resolve: {
			componentFactoryResolver: ComponentFactoryResolverService
		},
		data: {
			module: 'global-configuration',
			keepBreadcrumb: true
		},
		children: [
			{
				path: '',
				redirectTo: '',
				pathMatch: 'prefix'
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild([])],
	exports: [RouterModule],
	providers: [{
		provide: ROUTES,
		useFactory: (): Routes => {
			const route = JSON.parse(JSON.stringify(routes));
			// build route tree depend on the user permissions
			const childrenRoutes = setRoutesByPermissions(route[0].children);
			routes[0].canActivate = [RoleGuard];
			routes[0].resolve = {
				componentFactoryResolver: ComponentFactoryResolverService
			}
			routes[0].children = childrenRoutes;
			return routes;
		},
		multi: true
	}]
})
export class GlobalConfigurationRoutingModule {}
